let cached: number | null = null;

/**
 * Measures the system scrollbar thickness by creating a temporary element.
 * Returns 0 on systems with overlay scrollbars (e.g. macOS default).
 * The result is cached after the first measurement.
 */
export function getScrollbarThickness(): number {
  if (cached !== null) return cached;

  const el = document.createElement("div");
  el.style.cssText = "overflow:scroll;width:100px;height:100px;position:absolute;top:-9999px";
  document.body.appendChild(el);
  cached = el.offsetHeight - el.clientHeight;
  document.body.removeChild(el);
  return cached;
}
